(() => {
  const AVAIL_PREFIX = "MilsensVariantAvailability-";
  const POLL_MS = 250;
  const POLL_MAX = 40; // 10s

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function log(...args) {
    // Décommente si tu veux debug
    // console.log("[MILSENS WB]", ...args);
  }

  function safe(fn) {
    try { fn(); } catch (e) {
      console.warn("[MILSENS WB] error ignored:", e);
    }
  }

  function getSectionId(el) {
    const sec = el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace("shopify-section-", "") : null;
  }

  function getAvailabilityMap(sectionId) {
    const node = document.getElementById(`${AVAIL_PREFIX}${sectionId}`);
    if (!node) return null;

    try {
      const data = JSON.parse(node.textContent || "{}");
      const map = new Map();
      (data.variants || []).forEach(v => map.set(String(v.id), !!v.available));
      return map;
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariantId(root) {
    const selected = root.querySelector(".new-form-option.selectedWB[data-variant-id]");
    if (selected) return selected.getAttribute("data-variant-id");

    // fallback: WideBundle peut ne pas avoir encore mis selectedWB
    const first = root.querySelector(".new-form-option[data-variant-id]");
    return first ? first.getAttribute("data-variant-id") : null;
  }

  function setOptionDisabled(opt, disabled) {
    opt.classList.toggle("is-disabled", !!disabled);
    opt.setAttribute("data-wb-disabled", disabled ? "true" : "false");

    // On bloque uniquement les cartes en rupture
    opt.style.pointerEvents = disabled ? "none" : "";
    opt.style.cursor = disabled ? "not-allowed" : "";
  }

  function setAtcDisabled(atc, disabled) {
    // IMPORTANT : jamais pointer-events none ici
    atc.classList.toggle("is-disabled", !!disabled);
    atc.setAttribute("aria-disabled", disabled ? "true" : "false");
    atc.setAttribute("data-wb-disabled", disabled ? "true" : "false");

    if (disabled) {
      atc.style.background = "#bdbdbd";
      atc.style.backgroundImage = "none";
      atc.style.boxShadow = "none";
      atc.style.filter = "grayscale(1)";
      atc.style.transform = "none";
      atc.style.cursor = "not-allowed";

      // On NE touche PAS innerHTML (WideBundle gère son prix)
      // Si tu veux afficher "Épuisé", je te le fais en CSS via ::before plutôt.
    } else {
      atc.style.background = "";
      atc.style.backgroundImage = "";
      atc.style.boxShadow = "";
      atc.style.filter = "";
      atc.style.transform = "";
      atc.style.cursor = "";
      atc.setAttribute("aria-disabled", "false");
      atc.removeAttribute("data-wb-disabled");
      atc.classList.remove("is-disabled");
    }
  }

  let refreshing = false;
  function refresh(root) {
    if (refreshing) return; // anti boucle / anti spam
    refreshing = true;

    safe(() => {
      const sectionId = getSectionId(root);
      if (!sectionId) return;

      const map = getAvailabilityMap(sectionId);
      if (!map) return;

      // 1) options
      $$(".new-form-option[data-variant-id]", root).forEach(opt => {
        const vid = opt.getAttribute("data-variant-id");
        const available = map.get(String(vid));
        setOptionDisabled(opt, available === false);
      });

      // 2) ATC selon sélection
      const atc = $("#new-form-atc", root);
      const selectedVid = getSelectedVariantId(root);
      if (!atc || !selectedVid) return;

      const selectedAvailable = map.get(String(selectedVid));
      setAtcDisabled(atc, selectedAvailable === false);
    });

    refreshing = false;
  }

  function bind(root) {
    if (root.dataset.milsensBound === "1") return;
    root.dataset.milsensBound = "1";

    // Refresh initial
    refresh(root);

    // Quand on clique sur une option
    root.addEventListener("click", (e) => {
      const opt = e.target.closest(".new-form-option[data-variant-id]");
      if (opt) setTimeout(() => refresh(root), 0);
    });

    // Bloquer le clic ATC si disabled (sans casser la page)
    root.addEventListener("click", (e) => {
      const atc = e.target.closest("#new-form-atc");
      if (!atc) return;

      const disabled =
        atc.getAttribute("data-wb-disabled") === "true" ||
        atc.getAttribute("aria-disabled") === "true" ||
        atc.classList.contains("is-disabled");

      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Petit polling au début (WideBundle peut changer selectedWB après injection)
    let n = 0;
    const t = setInterval(() => {
      n++;
      refresh(root);
      if (n >= 12) clearInterval(t); // 3s suffisent
    }, 250);
  }

  function boot() {
    // On attend que WideBundle injecte #new-form (jusqu'à 10s)
    let tries = 0;
    const timer = setInterval(() => {
      tries++;
      const root = document.getElementById("new-form");
      if (root) {
        clearInterval(timer);
        bind(root);
      } else if (tries >= POLL_MAX) {
        clearInterval(timer);
      }
    }, POLL_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();